import coreAxios from 'axios';
import axios, { axiosNS } from '../../../services/axios';
import { axiosNTL, axiosNL, axiosNT } from '../../../services/axios';
import _ from 'lodash';

import ContentData from '../types/ContentData';
import { ContentListFilterData } from '../types/ContentFilterData';
import { getContentSubTypeCode, convertSubjectWithId, convertSubjectIdFromObjectToString, getPropertyValue, getUserType } from '../../../utils';
import { getQuestionTypeName } from '../components/ContentCreate/ParagraphCreate';
import { ACADEMIC_STAT, VALIDATION } from '../constant/content';
import { FILTER_CATEGORIES, USER_TYPE } from '../../../constants/comman';

const changeInFilter = (filter: ContentListFilterData) => {
	filter.contentTypeCode = "";
	filter.contentSubTypeCode = "";
	filter.status = "";
	filter.tags = "";
	filter.courses = "";
	filter.classes = "";
	filter.difficulty = "";
	filter.skills = "";
	filter.createdBy = "";
	filter.publishedBy = "";
	filter.previousExams = "";
	if (filter.contentFilterData) {
		filter.contentFilterData.forEach(f => {
			if (f.filterValue == "contentType") {
				//content type code will be add here
				f.filters.forEach(ff => {
					if (ff.isSelected == true) {
						filter.contentTypeCode += ff.filterValue + ",";
					}

					//sub content type
					ff.filters.forEach(fff => {
						if (fff.isSelected == true) {
							filter.contentSubTypeCode += fff.filterValue + ","
						}
					});
				})
			}

			else if (f.filterValue == "status") {
				//content type code will be add here
				f.filters.forEach(ff => {
					if (ff.isSelected == true) {
						filter.status += ff.filterValue + ",";
					}
				})
			}
			else if (f.filterValue && f.filterValue.search("tags") != -1) {
				if (typeof (filter.tags) != 'object') {
					filter.tags = {}
				}
				//all others all tag
				let ft = f.filterTitle;
				f.filters.forEach(ff => {
					if (ff.isSelected == true) {
						if (filter.tags && !filter.tags.hasOwnProperty(ft)) {
							//@ts-ignore
							filter.tags[ft] = ff.filterValue + ",";
						}
						else {
							//@ts-ignore
							filter.tags[ft] += ff.filterValue + ",";
						}

					}
				})
			}
			else if (f.filterValue == "courses") {
				f.filters.forEach(ff => {
					if (ff.isSelected == true) {
						filter.courses += ff.filterValue + ",";
					}
				})
			}
			else if (f.filterValue == "classes") {
				f.filters.forEach(ff => {
					if (ff.isSelected == true) {
						filter.classes += ff.filterValue + ",";
					}
				})
			}
			else if (f.filterValue == "difficulty") {
				f.filters.forEach(ff => {
					if (ff.isSelected == true) {
						filter.difficulty += ff.filterValue + ",";
					}
				})
			}
			else if (f.filterValue == "skill") {
				f.filters.forEach(ff => {
					if (ff.isSelected == true) {
						filter.skills += ff.filterValue + ",";
					}
				})
			}
			else if (f.filterValue == "createdby") {
				f.filters.forEach(ff => {
					if (ff.isSelected == true) {
						filter.createdBy += ff.filterValue + ",";
					}
				})
			}
			else if (f.filterValue == "publishedby") {
				f.filters.forEach(ff => {
					if (ff.isSelected == true) {
						filter.publishedBy += ff.filterValue + ",";
					}
				})
			} else if (f.filterValue === FILTER_CATEGORIES.PREVIOUS_YEAR_CONTENT) {
				filter.previousExams = (f.filters || []).filter(filter => filter.isSelected).map(filter => filter.filterValue).join(',');
			}
		});
		delete filter.contentFilterData
	}
	if (filter.questionStatus && filter.questionStatus !== ACADEMIC_STAT[filter.contentMenu || ''].COMPLETED.KEY) {
		filter.status = filter.questionStatus;
		delete filter.questionStatus;
	}
	return filter;
}
const list = (filter: ContentListFilterData, page = 1, limit = 20) => {
	if (getUserType(USER_TYPE.STUDENT)) {
		filter.contentMenu = VALIDATION.CREATED_BY_ME;
	}
	return axiosNT
	.post(`content/getContentList?page=${page}&limit=${limit}`, changeInFilter(JSON.parse(JSON.stringify(filter))))
	.then((res: any) => {
		const contents: ContentData[] = getPropertyValue(res, 'responseObject.validationRequestsData') ? (res.responseObject.validationRequestsData) : res.responseObject;
		return Promise.resolve(contents);
	});
}
const contentList = (filter: any, page = 1, limit = 20) => {
	return axiosNT
		.post(`content/getContentList?page=${page}&limit=${limit}`, changeInFilter(JSON.parse(JSON.stringify(filter))))
		.then((res: any) => {
			const contents: ContentData[] = getPropertyValue(res, 'responseObject.validationRequestsData') ? (res.responseObject.validationRequestsData) : res.responseObject;
			return Promise.resolve({ contents, statusCode: res.statusCode });
		});
}


const suggestions = (filter: ContentListFilterData) => axiosNTL
	.post(`content/getContentSuggestions`, filter)
	.then((res: any) => {
		const contents: ContentData[] = res.responseObject;
		return Promise.resolve(contents);
	});


const count = (filter: ContentListFilterData) => axiosNT
	.post(`content/getContentListCount`, changeInFilter(JSON.parse(JSON.stringify(filter))))
	.then((res: any) => {
		const contentCounts: any = res.responseObject;
		return Promise.resolve(contentCounts);
	});

const countAll = (filterAll: any) => {
	filterAll.filterContent = changeInFilter(JSON.parse(JSON.stringify(filterAll.filterContent)))
	return axiosNTL
		.post(`content/getContentListCountAll`, filterAll)
		.then((res: any) => {
			const cc: number[] = res.responseObject;
			return Promise.resolve(cc);
		});
}

const markAsFavourite = (id: string, isFavourite: number = 1) => axiosNTL
	.get(`/content/markAsFavourite/${id}?isFavourite=${isFavourite}`)
	.then((res: any) => {
		return Promise.resolve();
	});

const getActiveListOfDisabled = (id: string) => axiosNTL
	.get(`/myLibraryQueue/active-list-for-disable-grace-rule/${id}`)
	.then((res: any) => {
		return Promise.resolve(res);
	});

const details = (id: string) => axiosNT
	.get(`/content/getContentDetails/${id}`)
	.then((res: any) => {
		const content: ContentData = res.responseObject;
		return Promise.resolve(content);
	});


const detailsNTL = (id: string) => axiosNTL
	.get(`/content/getContentDetails/${id}`)
	.then((res: any) => {
		const content: ContentData = res.responseObject;
		if (!content.content) {
			content.content = {
				content: []
			};
		}
		return Promise.resolve(content);
	});

const getSpecialPurposeCourses = (purpose: string) =>
axiosNTL.get(`/courseType?specialPurposes=${purpose}&limit=50`).then((res: any) => {
	const content: any = res.responseObject;
	return Promise.resolve(content);
});

const detailsByConten_IdNTL = (id: string) => axiosNTL
	.get(`/content/getContentDetails/${id}?content_Id=1`)
	.then((res: any) => {
		const content: ContentData = res.responseObject;
		if (!content.content) {
			content.content = {
				content: []
			};
		}
		return Promise.resolve(content);
	});
const fetchNotesDataById = (id: string) => axiosNTL
	.get(`/note/${id}`)
	.then((res: any) => {
		return Promise.resolve(res);
	});

const remove = (contentList: ContentData[]) => {
	let contentTypeCode: string = "";
	let idArray: string[] = [];

	contentList.forEach(c => {
		if (c.passageData && c.passageData.length) {
			c.passageData.forEach(function (passageItem: any) {
				idArray.push(passageItem.id);
			});
		} else {
			idArray.push(c.content_Id);
		}
		if (c.contentTypeCode === 'studymaterial') {
			contentTypeCode += c.contentSubTypeCode + ",";
		} else {
			contentTypeCode += c.masterVariationQuestionId ? `question,` : c.contentTypeCode + ",";
		}
	});

	return axios
		.delete(`/content/delete?key=${contentTypeCode}`, { data: { idArray } })
		.then((res: any) => {
			return Promise.resolve();
		});
};

const clone = (id: string) => {

	return axios
		.post(`/content/clone/${id}`)
		.then((res: any) => {
			return Promise.resolve(res.responseObject);
		});
}

const share = (body: any) => {
	return axios
		.post(`/content/share`, body)
		.then((res: any) => {
			return Promise.resolve(res);
		});
}

const editLink = (content: ContentData, queryString: any = null) => {
	let link = "/content/edit/";

	switch (content.contentTypeCode) {
		case 'testpapers': {
			return link + content.contentTypeCode + "/" + content.content.settings.testType + "/" + content._id;
		}

		case 'studymaterial': {
			return link + "studymaterial" + "/" + "notes" + "/" + content._id;
		}
		case 'note': {
			return link + "studymaterial" + "/" + "notes" + "/" + content._id;
		}

		case 'sampleproblem': {
			return link + "studymaterial" + "/" + "sampleproblem" + "/" + content._id;
		}

		case 'formulas': {
			return link + "studymaterial" + "/" + "formulas" + "/" + content._id;
		}

		case 'audios': {
			return link + "studymaterial" + "/" + "audios" + "/" + content._id;
		}

		case 'videos': {
			return link + "studymaterial" + "/" + "videos" + "/" + content._id;
		}

		case 'question': {
			const contentSubTypeCode = content.masterVariationQuestionId
				? _.get(content.masterVariationQuestionData, 'questionCode', '')
				: content.contentSubTypeCode
			let url;
			switch (getContentSubTypeCode(contentSubTypeCode)) {
				case '0': {//SMCQ
					url = link + content.contentTypeCode + "/" + contentSubTypeCode + "/" + content._id;
				}
				case '1': {//Matrix
					url = link + content.contentTypeCode + "/" + contentSubTypeCode + "/" + content._id;
				}
				case '2': {//true/false
					url = link + content.contentTypeCode + "/" + contentSubTypeCode + "/" + content._id;
				}
				case '3': {//blank
					url = link + content.contentTypeCode + "/" + contentSubTypeCode + "/" + content._id;
				}
				case '4': {//descriptive
					url = link + content.contentTypeCode + "/" + contentSubTypeCode + "/" + content._id;
				}
				case '5': {//Paragraph
					url = link + content.contentTypeCode + "/" + contentSubTypeCode + "/" + content._id;
				}
				case '6': {//Numerical
					url = link + content.contentTypeCode + "/" + contentSubTypeCode + "/" + content._id;
				}
				case '7': {//Integer
					url = link + content.contentTypeCode + "/" + contentSubTypeCode + "/" + content._id;
				}
				case '8': {//MMCQ
					url = link + content.contentTypeCode + "/" + contentSubTypeCode + "/" + content._id;
				}
			}
			if (queryString && queryString.vKey) {
				url = `${url}?vKey=${queryString.vKey}`
			}
			return url
		}
	}
	return link;
}

const save = (contentId: string | null, contentTypeCode: string, postData: any, runInBackground: boolean = false, metaObject?: any, defaultMethod?: string) => {
	//deep copy
	postData = JSON.parse(JSON.stringify(postData));
	if (metaObject !== undefined && metaObject.type === 'studymaterial' && metaObject.subType === "formulas") {
		postData.contentTypeCode = 'formulas';
	}
	if (postData && postData.questionCode == 6) {
		if (postData.content && postData.content[0] && postData.content[0].correctAnswer) {
			const data = postData.content[0].correctAnswer.data
			if (data && data[0]) {
				data[0].value = Number(data[0].value)
				data[0].negativeTolerance = Number(data[0].negativeTolerance)
				data[0].positiveTolerance = Number(data[0].positiveTolerance)
			}
		}
	}

	//subjects key subject id from object to string id
	const { conceptCodes, conceptIds } = convertSubjectIdFromObjectToString(postData.subjects);
	if (postData.secondarySubjects) {
		convertSubjectIdFromObjectToString(postData.secondarySubjects);
	}
	postData.conceptCodes = conceptCodes;
	postData.conceptCode = conceptCodes;
	postData.conceptIds = conceptIds;

	if (postData.questionCode == 5) {
		// fill outer subject array for paragraph question  
		let subjects: any = []
		let conceptId: any[] = [];
		let conceptCodes: any[] = [];
		let typeOfQuestion: any = null
		if (postData.content && postData.content.length > 0) {
			postData.content.forEach((content: any) => {
				if (content.typeOfQuestion !== undefined &&
					content.typeOfQuestion !== null &&
					!typeOfQuestion
				) {
					typeOfQuestion = content.typeOfQuestion
				}
				if (content.subjects) {
					convertSubjectWithId(content.subjects, conceptId, conceptCodes);
					subjects = subjects.concat(content.subjects);
				}
				if (content.secondarySubjects) {
					convertSubjectWithId(content.secondarySubjects, [], []);
				}
			})
		}
		// used for set type of question in paragraph 
		if (typeOfQuestion) {
			postData['passageQuestionType'] = getQuestionTypeName(parseInt(typeOfQuestion))
			postData['passageQuestionCode'] = typeOfQuestion
		}
		postData.subjects = subjects;
		postData.conceptId = conceptId;
		postData.conceptCode = conceptCodes;
		if (postData.content.length) {
			for (let i = 0; i < postData.content.length; i++) {
				if (postData.content[i].typeOfQuestion === '6') {
					if (postData.content[i].correctAnswer.data && postData.content[i].correctAnswer.data.length) {
						if (!postData.content[i].correctAnswer.data[0].positiveTolerance) {
							postData.content[i].correctAnswer.data[0].positiveTolerance = null;
						}
						if (!postData.content[i].correctAnswer.data[0].negativeTolerance) {
							postData.content[i].correctAnswer.data[0].negativeTolerance = null;
						}
					}
				}
			}
		}
	}
	if ((postData.questionCode === 3 || postData.questionCode === 5) &&
		(postData.questionType === "Blanks" || postData.passageQuestionType === "Blanks")) {
		if (Array.isArray(((postData.content || [])[0] || {}).correctAnswer)) {
			postData.content.forEach((element: any) => {
				const answerData = element.correctAnswer;
				const updatedPayload = {
					answerType: "id",
					data: Array.isArray(answerData) ? answerData.map((answer: any) => ({ value: answer.value, weightage: "0" })) : [{value: {}, weightage: "0"}]
				}
				element.correctAnswer = updatedPayload;
			})
		}
	}
	// // TODO: Suhail please check the logic here while submission
	// //subjects key subject id from object to string id
	// _.map(postData.content, (content: any) => {
	// 	if (!_.isEmpty(content['subjects'])) {
	// 		// let newSubjects: any[] = [];
	// 		let conceptIds: any[] = [];
	// 		_.map(content.subjects, (s, sI: number) => {
	// 			if(!s.subjectId) {
	// 				return 
	// 			}
	// 			s.subjectId = _.get(s,'subjectId._id');
	// 			_.map(s.subSubjects, (ss: any, ssI: number) => {
	// 				if(!ss.subSubjectId) {
	// 					return 
	// 				}
	// 				if (ss.subSubjectId && ss.subSubjectId._id) {
	// 					ss.subSubjectId = ss.subSubjectId._id || null;
	// 					_.map(ss.chapters, (ch: any, chI: number) => {
	// 						if(!ch.chapterId) {
	// 							return 
	// 						}
	// 						ch.chapterId = _.get(ch,'chapterId._id', null);
	// 						// if (!s['chapters']) {
	// 							s['chapters'] = [];
	// 						// }
	// 						s['chapters'].push(ch);
	// 						_.map(ch.concepts, (co: any, coI: number) => {
	// 							if(!co.conceptId) {
	// 								return 
	// 							}
	// 							co.conceptId = _.get(co,'conceptId._id');
	// 							conceptIds.push(co.conceptId._id);
	// 							co.classId = _.get(co,'classId._id');
	// 						})
	// 					})
	// 				}
	// 			})
	// 		});
	// 	}
	// });

	let url = "";
	let method = defaultMethod || "post";

	if (contentId != "") {
		method = (contentTypeCode === 'videos' || contentTypeCode === 'audios') ? 'put' : 'patch';
		//update links

		switch (contentTypeCode) {
			case 'testpapers': {
				url = `test/updateTest/${postData._id}`;
				break;
			}
			case 'studymaterial': {
				url = `/note/`;
				method = "put"
				break;
			}
			case 'sampleproblem': {
				url = `/sampleProblem/updateSampleProblem/${postData._id}`;
				break;
			}
			case 'formulas': {
				url = `/formula/updateFormula/${postData._id}`;
				break;
			}
			case 'videos': {
				url = "video";
				break;
			}
			case 'audios': {
				url = "audio";
				break;
			}
			case 'question': {
				url = '/question/questionEdit';
				method = 'put';
				break;
			}
			default:
				break;
		}
	} else {
		//create links
		switch (contentTypeCode) {
			case 'testpapers': {
				url = "test/addTest";
				break;
			}
			case 'note': {
				url = '/note';
				break;
			}
			case 'sampleproblem': {
				url = '/sampleProblem/createSampleProblem/';
				break;
			}
			case 'formulas': {
				url = '/formula/createFormula/';
				break;
			}
			case 'audios': {
				url = "audio";
				break;
			}
			case 'videos': {
				url = "video";

				break;
			}
			case 'question': {
				url = '/question/questionSave';
				break;
			}
			default:
				break
		}
	}

	//set loader false if in running in background
	let request = axios;
	if (runInBackground) {
		request = axiosNTL;
	}
	const studentUser = getUserType(USER_TYPE.STUDENT);
	studentUser && !postData.validationStatus && (postData.subjects || []).forEach((subject: any) => {
		subject.chapters = [];
		subject.subSubjects = [];
	});
	//@ts-ignore
	return request[method](url, postData)
		.then((res: any) => {
			return Promise.resolve(res);
		});
}

const saveQuestion = (questionData: any) =>
	axios.put('question/questionEdit', questionData)
		.then((res: any) => {
			return Promise.resolve(res);
		});

const publishContentRefresh = (data: any) => {
	return axios.post('/question/questionByList', data)
		.then((res: any) => {
			return Promise.resolve(res.responseObject);
		});
}

const publish = (postData: any, authors: string[], type: string, publish: boolean = true) => {
	//@ts-ignore
	const publishId = postData.publishId || postData._id
	return axios.put(`/content/publishContent/${publishId}?contentType=${type}&publish=${publish}&replaceDoc=true`, { ...postData, authors: authors })
		.then((res: any) => {
			if (res.statusCode !== 200 && res.statusCode !== 201) {
				return Promise.reject(res.responseObject)
			}
			return Promise.resolve(res.responseObject);
		});
}

const publishVideoContent = (publishData: any, contentType: any) => {
	const publishId = publishData.publishId || publishData._id
	return axiosNTL.put(`/content/publishContent/${publishId}?contentType=${contentType}&publish=true&replaceDoc=true`, publishData)
		.then((res: any) => {
			return Promise.resolve(res.responseObject);
		});
}

const addToQueueQuestion = (postData: ContentData, authors: string[], type: string, publish: boolean = true) => {
	return axios.post(`myLibraryQueue/addToQueue`, { ...postData, authors: authors })
		.then((res: any) => {
			return Promise.resolve(res);
		});
}

const addToQueue = (postData: any) => {
	return axios.post(`myLibraryQueue/addToQueue`, postData)
		.then((res: any) => {
			return Promise.resolve(res);
		});
}

const rePublish = (postData: any, authors: string[], type: string, publish: boolean = true) => {
	const publishId = (postData && postData.publishId) || (postData && postData.draftId && postData.draftId.publishId) || postData._id

	return axios.put(`/content/publishContent/${publishId}?contentType=${type}&publish=${publish}&replaceDoc=true`, { ...postData, authors: authors })
		.then((res: any) => {
			if (res.statusCode !== 200 && res.statusCode !== 201) {
				return Promise.reject(res.responseObject)
			}
			return Promise.resolve(res.responseObject);
		});
}

const getContentHistory = (id: string, type: string) => {
	return axiosNS.get(`/content/contentHistory/${id}/${type}`)
		.then((res: any) => {
			return Promise.resolve(res.responseObject);
		});
}

const publishQuestions = (postData: any) => {
	return axios.put(`/content/publishCompleteDraftQuestion`, { postData })
		.then((res: any) => {
			return Promise.resolve(res.responseObject);
		});
}

const usedIn = (contentId: string) => {
	return axiosNTL.get(`/content/usedIn/${contentId}`)
		.then((res: any) => {
			return Promise.resolve(res.responseObject);
		})
}
const getQuestion = (id: string) => {
	return axiosNTL.get(`/question/getQuestion/${id}`)
		.then((res: any) => {
			return Promise.resolve(res.responseObject);
		})
}

const getUserForFilter = () => axiosNTL
	.post(`/content/getUserFilterDetails`)
	.then((res: any) => {
		if (res.statusCode == 200) {
			const dataObj = res.responseObject
			return Promise.resolve(dataObj);
		}
	});


const getQuestionAttemps = (data: any) => axiosNTL
	.post(`/content/type/question/attempts`, data)
	.then((res: any) => {
		if (res.statusCode == 200) {
			const dataObj = res.responseObject
			return Promise.resolve(dataObj);
		}
	});

const getTestAttemps = (data: any) => axiosNTL
	.post(`/content/type/test/attempts`, data)
	.then((res: any) => {
		if (res.statusCode == 200) {
			const dataObj = res.responseObject
			return Promise.resolve(dataObj);
		}
	});

const getEditLockInfo = (params: any, queryStrings: any) => axiosNT
	.get(`content/getContentLock/${params._id}?eventType=${queryStrings.eventType}`) // TODO: add lock api
	.then((res: any) => {
		if (res.statusCode == 200) {
			return Promise.resolve(res);
		}
	});

const assignTest = (params: any) => axiosNT
	.patch(`course/addOrgTest/${params.courseId}/${params.courseItemId}/${params.testId}`) // TODO: assign test api
	.then((res: any) => {
		if (res.statusCode == 200) {
			return Promise.resolve(res);
		}
	});

const getBenchmarks = (params: any) => axiosNTL.get('/benchmark', { params }).then((res: any) => {
	if (res.statusCode === 200) {
		return Promise.resolve(res.responseObject);
	}
})
const updateBenchmarks = (reqBody: any) => axiosNTL.put('/benchmark/question', reqBody).then((res: any) => res);

const getCoursesByConceptCode = (reqBody: any) => axiosNTL.post('/course/courses-by-concept-codes', reqBody).then((res: any) => {
	if (res.statusCode === 200) {
		return Promise.resolve(res.responseObject);
	}
})
const fetchBenchMarkInfo = (queryStrings: any) => axiosNT
	.get(`benchmark?type=${queryStrings.type}&typeId=${queryStrings.typeId}`) // TODO: fetch benchmark api
	.then((res: any) => {
		if (res.statusCode === 200) {
			return Promise.resolve(res);
		}
	})
const getQuestionAnalytics = (qId: string) => axiosNTL
	.get(`/question/analytics?qId=${qId}`)
	.then((res: any) => {
		if (res.statusCode != 200) {
			res.responseMessage = 'No Analytics have been generated for this question yet'
		}
		return Promise.resolve(res);
	});

const getRemedialQuestion = (qId: string) => axiosNTL
	.get(`/v4/remedial-questions?qId=${qId}`)
	.then((res: any) => {
		if (res.statusCode === 200) {
			return Promise.resolve(res);
		}
		return Promise.resolve({});
	});

const updateBenchMarkInfo = (payload: any = {}) => axiosNT
	.put(`benchmark/test`, payload) // TODO: update benchmark api
	.then((res: any) => {
		return Promise.resolve(res);
	});

const fetchGoalLevels = (queryStrings: any) => {
	let key: any = Object.keys(queryStrings)
	key = key[0]
	return axiosNTL
		.get(`goal-level?${key}=${queryStrings[key]}`) // TODO: fetch goal level api
		.then((res: any) => {
			if (res.statusCode == 200) {
				return Promise.resolve(res);
			}
		});
}

const getQuestionReviews = (queryParams: {
	questionId: string;
	reviewerType: string;
	reviewStatus: string;
	pageNumber?: number;
	reviwerId?: string;
}) =>
	axiosNTL.get('/question-reviews', {
		params: queryParams
	}).then((res: any) => {
		if (res.statusCode == 200) {
			const dataObj = res.responseObject
			return Promise.resolve(dataObj);
		}
	});

const getPresignedUrlForQuestionReviewAttachment = (payload: { fileName: string, questionId: string, contentType?: string }) => {
	return axiosNTL.get(`/question-reviews/${payload.questionId}/presigned-url?key=${payload.fileName}${payload.contentType ? '&contentType=' + payload.contentType : ''}`).then((res: any) => {
		return res.responseObject
	})
}

const generatePresignedUrl = (params: { key: string; location: string; id?: string, contentType?: string }, axiosInstance = axiosNTL) => {
	return axiosInstance.get(`/content/presigned-url`, { params }).then((res: any) => {
		return Promise.resolve(res.responseObject)
	})
}


const uploadAttachment = (payload: { file: File, uploadUrl: string, s3Fields: { [key: string]: any }, contentType?: string }) => {
	const { file, uploadUrl, s3Fields } = payload;
	const formData = new FormData();
	Object.keys(s3Fields).forEach((key) => {
		formData.append(key, s3Fields[key]);
	});
	formData.append('file', file, file.name)
	if (payload.contentType){
		formData.append('Content-Type', payload.contentType);
	}
	return coreAxios.post(uploadUrl, formData).then((res: any) => res);
}

const createQuestionReview = (payload: {
	questionId: string;
	reviewerName: string;
	reviewerId: string;
	issueArea: string;
	issueDescription: string;
	attachments: any[];
}) => axios.post('/question-reviews', { ...payload, reviewerType: 'author' }).then(res => Promise.resolve(res))

const updateQuestionReviewStatus = (payload: {
	reviewStatus: string,
	questionReviewId: string
}) => axiosNTL.put(`/question-reviews/${payload.questionReviewId}`, {
	reviewStatus: payload.reviewStatus
}).then(res => Promise.resolve(res))

const getTestAnalytics = (testId: string) => axiosNTL
	.get(`/test/analytics?testId=${testId}`)
	.then((res: any) => {
		if (res.statusCode != 200) {
			res.responseMessage = 'No Analytics have been generated for this question yet'
		}
		return Promise.resolve(res);
	});
const getContentSuggestions = (payload: any) => {
	let { type, id } = payload
	if (type.charAt(type.length - 1) != 's')
		type = type + 's';
	return axiosNTL
		.get(`/content/similar-contents/${type}/${id}`)
		.then((res: any) => {
			if (res.statusCode != 200) {
				res.responseMessage = 'something went wrong'
			}
			return Promise.resolve(res);
		});
}


const getUsersByClientIds = (payload: { clientIds: string[] }) => {
	const { clientIds } = payload

	return axiosNT.post(
		'/user/filtered-users',
		{
			"clientIds": clientIds

		}
	).then((res: any) => {
		return Promise.resolve(res.responseObject.users)
	})
}

const encryptPdf = (payload: { file: File }) => {
	const { file } = payload;
	const formData = new FormData();
	formData.append('file', file, file.name);
	return axiosNT.post('/content/pdf-transform', formData).then((res: any) => res);
};

const markAsResolved = (postData: any) => {
	return axios.put(`/question-reviews/mark-as-resolved`, postData)
	.then((res: any) => {
		if (res.statusCode != 200) {
			res.responseMessage = 'something went wrong'
		}
		return Promise.resolve(res);
	});
}

const publishInreviewContents = (payload: any) => {
	return axios.post('/content-validation/publish-before-validation', payload);
}

const contentService = {
	list,
	contentList,
	suggestions,
	count,
	countAll,
	markAsFavourite,
	details,
	detailsNTL,
	detailsByConten_IdNTL,
	remove,
	clone,
	share,
	editLink,
	save,
	publish,
	fetchNotesDataById,
	publishVideoContent,
	rePublish,
	addToQueueQuestion,
	publishQuestions,
	usedIn,
	getQuestion,
	getUserForFilter,
	publishContentRefresh,
	getEditLockInfo,
	assignTest,
	getContentHistory,
	getQuestionAttemps,
	getTestAttemps,
	getActiveListOfDisabled,
	addToQueue,
	getBenchmarks,
	getCoursesByConceptCode,
	updateBenchmarks,
	fetchBenchMarkInfo,
	updateBenchMarkInfo,
	fetchGoalLevels,
	getQuestionReviews,
	createQuestionReview,
	updateQuestionReviewStatus,
	getPresignedUrlForQuestionReviewAttachment,
	uploadAttachment,
	getQuestionAnalytics,
	getRemedialQuestion,
	generatePresignedUrl,
	getTestAnalytics,
	getContentSuggestions,
	getUsersByClientIds,
	encryptPdf,
	getSpecialPurposeCourses,
	markAsResolved,
	saveQuestion,
	publishInreviewContents,
};

export default contentService;
